<div class="input-container">
    <a
        (click)="toggleCollapsed()"
        aria-controls="navbarDropdown"
        aria-expanded="false"
        class="horizontal collapsible-container"
        data-bs-toggle="collapse"
        href="#{{id}}"
        role="button"
    >
        <div class="icon-title-container">
            <i class="icon" [class]="icon"></i>
            <h3>
                <ng-container class="selection-counter" *ngIf="maxSelection === 0 && currentSelected !== 0 && id !== 'studentSelector'">{{currentSelected}}</ng-container>
                {{ title | translate }}
                <span  class="selection-counter" *ngIf="maxSelection === 0 && currentSelected !== 0 && id === 'studentSelector'">{{currentSelected}}</span>
                <span class="selection-counter" *ngIf="maxSelection !== 0">{{currentSelected}}/{{maxSelection}}</span>
            </h3>
        </div>
        <div class="icon" [ngClass]="isCollapsed ? 'i-angle-down' : 'i-angle-up'"></div>
    </a>
    <div class="collapse" [ngClass]="{ 'show': !isCollapsed }" id="{{id}}">

        <ng-content></ng-content>

    </div>
</div>
